export interface FormatCargoCoverageProps {
  amountDollars: string | null;
  currencyCode: string | null;
}

/*
Renders a carrier's cargo coverage like the rest of the app's money, a dollar
sign on the figure and then the currency code, but in whole dollars: coverage
is a limit on a certificate ("$250,000 CAD"), never a price with cents.

Records predating the cargo coverage requirement carry no amount and read
"Not specified", which is prose rather than a figure, so it gets no dollar sign.
*/
export function formatCargoCoverage(props: FormatCargoCoverageProps): string {
  const { amountDollars, currencyCode } = props;
  const amount = amountDollars ? parseFloat(amountDollars) : NaN;

  if (Number.isNaN(amount)) {
    return "Not specified";
  }

  const figure = `$${Math.round(amount).toLocaleString()}`;
  return currencyCode ? `${figure} ${currencyCode}` : figure;
}
